<template>
  <vxe-modal v-model="visible" title="button.editLocation" type="confirm" width="60%" @confirm="confirm">
    <a-form-model ref="form" :colon="false" :label-col="{span:8}" :model="location" :rules="rules" :wrapper-col="{span:16}" style="margin-left: -2%;margin-right: 2%">
      <a-row>
        <a-col :span="8">
          <a-form-model-item :label="$t('business.label.locationNo')" prop="no">
            <vxe-input v-model="location.no" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item :label="$t('business.label.locationName')" prop="name">
            <vxe-input v-model="location.name" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item :label="$t('business.label.storageRoom')" prop="storageRoom">
            <vxe-input v-model="location.storageRoom.name" :editable="false" style="width: 100%" @click="onStorageRoomSelect"/>
          </a-form-model-item>
          <storage-room-modal ref="storageRoomModal" @change="onStorageRoomChange"/>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="8">
          <a-form-model-item :label="$t('business.label.zone')" prop="zone">
            <vxe-input v-model="location.zone.name" :editable="false" style="width: 100%" @click="onZoneSelect"/>
          </a-form-model-item>
          <zone-modal ref="zoneModal" @change="onZoneChange"/>
        </a-col>
        <a-col :span="8">
          <a-form-model-item :label="$t('business.label.region')" prop="region">
            <vxe-select v-model="location.region.id" :options="regions" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item :label="$t('business.label.roadway')" prop="roadway">
            <vxe-input v-model="location.roadway" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="8">
          <a-form-model-item :label="$t('business.label.row')" prop="x">
            <vxe-number-input v-model="location.x" :min="0" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item :label="$t('business.label.layer')" prop="y">
            <vxe-number-input v-model="location.y" :min="0" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item :label="$t('business.label.column')" prop="z">
            <vxe-number-input v-model="location.z" :min="0" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="8">
          <a-form-model-item :label="$t('business.label.depth')" prop="depth">
            <vxe-number-input v-model="location.depth" :min="0" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item :label="$t('business.label.section')" prop="section">
            <vxe-input v-model="location.rack.section" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item :label="$t('business.label.side')" prop="side">
            <vxe-input v-model="location.rack.side" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="8">
          <a-form-model-item :label="$t('business.label.length')" prop="dimension.length">
            <vxe-number-input v-model="location.dimension.length" :min="0" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item :label="$t('business.label.width')" prop="dimension.width">
            <vxe-number-input v-model="location.dimension.width" :min="0" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item :label="$t('business.label.height')" prop="dimension.height">
            <vxe-number-input v-model="location.dimension.height" :min="0" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="8">
          <a-form-model-item :label="$t('business.label.volume')" prop="dimension.volume">
            <vxe-number-input v-model="location.dimension.volume" :min="0" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item :label="$t('business.label.weight')" prop="weight">
            <vxe-number-input v-model="location.weight" :min="0" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item :label="$t('business.label.shortNo')" prop="shortNo">
            <vxe-input v-model="location.shortNo" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="8">
          <a-form-model-item :label="$t('business.label.locationType')" prop="locationType">
            <vxe-select v-model="location.locationType" :options="locationTypes" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item :label="$t('business.label.locationStatus')" prop="locationStatus">
            <vxe-select v-model="location.locationStatus" :options="locationStatus" disabled style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item :label="$t('business.label.rackType')" prop="rackType">
            <vxe-select v-model="location.rackType" :options="rackTypes" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="8">
          <a-form-model-item :label="$t('business.label.storageType')" prop="storageType">
            <vxe-select v-model="location.storageType" :options="storageTypes" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item label="存放类型上限" prop="limitOfStorageType">
            <vxe-number-input v-model="location.limitOfStorageType" :min="0" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item :label="$t('business.label.pileupType')" prop="pileupType">
            <vxe-select v-model="location.pileupType" :options="pileupTypes" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="8">
          <a-form-model-item :label="$t('business.label.owner')" prop="owner">
            <vxe-input v-model="location.owner.name" :editable="false" style="width: 100%" @click="onOwnerSelect"/>
            <customer-modal ref="ownerModal" title="business.label.owner" @change="onOwnerChange"/>
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item :label="$t('business.label.saleClassification')" prop="saleClassification">
            <vxe-select v-model="location.saleClassification" :options="saleClassifications" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item label="输送线" prop="conveyor">
            <vxe-input v-model="location.conveyor.name" :editable="false" style="width: 100%" @click="()=>this.$refs.conveyorModal.open()"/>
            <field-modal ref="conveyorModal" :no="'CONVEYOR'" :show-value="false" :title="$t('business.label.conveyor')" @change="(conveyor)=>change(conveyor,'conveyor')"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="4">
          <a-form-model-item :label="$t('business.label.locking')" :label-col="{span:16}" :wrapper-col="{span:8}">
            <vxe-switch v-model="location.locking" disabled/>
          </a-form-model-item>
        </a-col>
        <a-col :span="4">
          <a-form-model-item :label="$t('business.label.mechanicalLocking')" :label-col="{span:16}" :wrapper-col="{span:8}">
            <vxe-switch v-model="location.mechanicalLocking" disabled/>
          </a-form-model-item>
        </a-col>
        <a-col :span="4">
          <a-form-model-item :label="$t('business.label.containerControl')" :label-col="{span:16}" :wrapper-col="{span:8}">
            <vxe-switch v-model="location.containerControl"/>
          </a-form-model-item>
        </a-col>
        <a-col :span="4">
          <a-form-model-item :label="$t('business.label.automatic')" :label-col="{span:16}" :wrapper-col="{span:8}">
            <vxe-switch v-model="location.automatic"/>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
  </vxe-modal>
</template>

<script>
import Vue from 'vue'
import { save } from '@/api/Api'
import { WAREHOUSE } from '@/store/mutation-types'
import FieldModal from '@/views/modal/FieldModal.vue'
import CustomerModal from '@/views/modal/CustomerModal.vue'
import StorageRoomModal from '@/views/modal/StorageRoomModal.vue'
import ZoneModal from '@/views/modal/ZoneModal.vue'
import { Location } from '@/api/dto/common/Location'
import { Identifier } from '@/api/dto/Identifier'
import { StorageRoom } from '@/api/dto/common/StorageRoom'
import { Zone } from '@/api/dto/common/Zone'
import { Party } from '@/api/dto/common/Party'

export default {
  name: 'LocationEdit',
  components: { CustomerModal, FieldModal, StorageRoomModal, ZoneModal },
  props: {
    regions: { type: Array, default: [] },
    locationTypes: { type: Array, default: [] },
    locationStatus: { type: Array, default: [] },
    rackTypes: { type: Array, default: [] },
    storageTypes: { type: Array, default: [] },
    pileupTypes: { type: Array, default: [] },
    saleClassifications: { type: Array, default: [] }
  },
  data() {
    return {
      visible: false,
      loading: false,
      warehouse: Vue.ls.get(WAREHOUSE),
      location: new Location(),
      rules: {
        'no': [{ required: true, message: '编号不能为空' }],
        'name': [{ required: true, message: '名称不能为空' }],
        'storageRoom': [{ required: true, message: '库房不能为空' }],
        'zone': [{ required: true, message: '区域不能为空' }],
        'roadway': [{ required: true, message: '巷道不能为空' }],
        'x': [{ required: true, message: '排不能为空', type: 'number' }],
        'y': [{ required: true, message: '层不能为空', type: 'number' }],
        'z': [{ required: true, message: '列不能为空', type: 'number' }],
        'dimension.length': [{ required: true, message: '长不能为空', type: 'number' }],
        'dimension.width': [{ required: true, message: '宽不能为空', type: 'number' }],
        'dimension.height': [{ required: true, message: '高不能为空', type: 'number' }],
        'dimension.volume': [{ required: true, message: '体积不能为空', type: 'number' }],
        'locationType': [{ required: true, message: '货位类型不能为空' }],
        'storageType': [{ required: true, message: '存放类型不能为空' }],
        'pileupType': [{ required: true, message: '码放类型不能为空' }],
        'saleClassification': [{ required: true, message: '销售分类不能为空' }]
      }
    }
  },
  methods: {
    onStorageRoomSelect() {
      this.$refs.storageRoomModal.open({ available: true })
    },
    onStorageRoomChange(data) {
      this.location.storageRoom = new StorageRoom(data[0])
      this.location.zone = new Zone()
    },
    onZoneSelect() {
      this.$refs.zoneModal.open({ 'storageRoom.id': this.location.storageRoom.id })
    },
    onZoneChange(data) {
      this.location.zone = new Zone(data[0])
    },
    onOwnerSelect() {
      this.$refs.ownerModal.open({ available: true, 'type.ordinal': 1 })
    },
    onOwnerChange(data) {
      this.location.owner = new Party(data[0])
    },
    add() {
      this.edit()
      this.location.available = true
    },
    edit(record) {
      this.visible = true
      this.location = new Location(record)
    },
    save() {
      this.loading = true
      const location = this.location.toJSONObject()
      location.warehouse = this.warehouse
      save('locationPersister', location).then(res => {
        if (res.success) {
          this.location = new Location(res.result)
          this.$message.success('保存成功')
          this.$emit('success')
          this.visible = false
        }
      }).finally(() => this.loading = false)
    },
    enable(record, available) {
      this.location = new Location(record)
      this.location.available = available
      this.save()
    },
    change(changeData, fieldName) {
      if (changeData.length === 0) {
        this.location[fieldName] = new Identifier()
      } else {
        this.location[fieldName] = Object.assign(new Identifier(), changeData[0])
      }
    },
    confirm() {
      this.$refs.form.validate((success) => {
        if (success) {
          this.save()
        }
      })
    }
  }
}
</script>